module.exports = __webpack_public_path__ + "img/home-rbn-12.8985ff51.png";